

import __layout_0 from '/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/home.vue'
export const layouts = {
'404': () => import('/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/404.vue'),
'blank': () => import('/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/blank.vue'),
'blog': () => import('/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/blog.vue'),
'default': () => import('/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/default.vue'),
'home': __layout_0,
'user': () => import('/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/user.vue'),
'wireframe': () => import('/home/runner/work/vuetify/vuetify/packages/docs/src/layouts/wireframe.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
